import type { ReactNode } from 'react';
import { IconType } from '../components';
import { ExportStatus } from '../components/status-tag';
import { UserRelation } from './auth';
import { CreditUsageType } from './credit-usage';
import { ArchiveStatus, Nullable } from './global';

export enum EnrichmentState {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  IN_PROGRESS = 'IN_PROGRESS',
  EXPORTING = 'EXPORTING',
  FAILED = 'FAILED',
}

export enum EnrichmentAction {
  SCRAPE = 'SCRAPE',
  SNIPPET = 'SNIPPET',
  AI_SNIPPET = 'AI_SNIPPET',
}

export enum EnrichmentMode {
  PERSON = 'PERSON_TEMPLATE',
  COMPANY = 'COMPANY_TEMPLATE',
  AI_PERSONALITY = 'AI_PERSONALITY_TEMPLATE',
}

export enum EnrichmentOptionTypeEnum {
  CONTACT_STORAGE_BASIC = 'CONTACT_STORAGE_BASIC',
  CONTACT_REVEAL_PROFILE = 'CONTACT_REVEAL_PROFILE',
  CONTACT_REVEAL_ANALYSIS = 'CONTACT_REVEAL_ANALYSIS',
  CONTACT_REVEAL_EMAIL = 'CONTACT_REVEAL_EMAIL',
  CONTACT_REVEAL_PHONE_CACHED = 'CONTACT_REVEAL_PHONE_CACHED',
}

export interface EnrichOption {
  icon: IconType;
  title: string;
  description?: string;
  creditUsage: number;
  creditCostType: CreditUsageType;
  type: EnrichmentOptionTypeEnum;
  active: boolean;
  gridSize?: number;
  isMandatory?: boolean;
  tooltip?: (credit: number) => ReactNode;
}

export type EnrichOptionsType = Partial<{
  [key in EnrichmentTypeEnum]: EnrichOption[];
}>;

export type EnrichmentSetting = {
  deduplicate: true;
  options: null;
};

export type EnrichmentStatistics = {
  total: number;
  valid: number;
  matched: number;
};

export interface Enrichment {
  id: string;
  type: EnrichmentTypeEnum;
  name: string;
  records: number;
  workspace: {
    id: string;
    user: {
      id: string;
      username: string;
      firstName: string;
      lastName: string;
    };
  };
  labels: Array<unknown>;
  status: ExportStatus;
  created: string;
  modified: string;
  statistics: EnrichmentStatistics;
  folder: Nullable<EnrichmentFolder>;
  user: UserRelation;
  title: string;
  export: string;
  credits: number;
  description: null;
  state: EnrichmentState;
  template: {
    name: string;
    setting: Record<string, any>;
  };
}

export interface AddEnrichment {
  title: string;
  action: EnrichmentAction;
  folder: Nullable<{
    id: string;
  }>;
  exportSetting: Record<string, any>;
  data: {
    url: string;
  }[];
}

export interface ModifyEnrichment {
  folder?: Nullable<{
    id: string;
  }>;
  status: ArchiveStatus;
}

export interface EnrichmentFolder {
  id: string;
  created: string;
  user: UserRelation;
  name: string;
  status: ArchiveStatus;
}

export interface EnrichmentAddFolder {
  name: string;
}
